export const GIFT_CLIENT_FIELD_LIST = [
  "introducer_name",
  "recipient_name",
  "theme",
  "tech_comfort",
  "work",
  "outside",
  "personality",
  "downplay",
  "lightup",
  "avoid",
  "completed_at",
  "retention_state",
];

export const GIFT_CLIENT_SELECT = GIFT_CLIENT_FIELD_LIST.join(", ");

const GIFT_LINK_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const PUBLIC_GIFT_HOSTS = new Set([
  "thegiftconversation.com",
  "www.thegiftconversation.com",
]);

export function resolvePastedGiftLink(rawValue, currentOrigin) {
  const value = typeof rawValue === "string" ? rawValue.trim() : "";

  if (!value) {
    return { destination: "", error: "Paste the complete gift link first." };
  }

  let currentUrl;
  let candidate;

  try {
    currentUrl = new URL(currentOrigin);
    const normalizedValue = /^(?:www\.)?thegiftconversation\.com\//i.test(value)
      ? `https://${value}`
      : value;
    candidate = new URL(normalizedValue, currentUrl.origin);
  } catch {
    return { destination: "", error: "That does not look like a valid link." };
  }

  const isAllowedHost = candidate.hostname === currentUrl.hostname
    || PUBLIC_GIFT_HOSTS.has(candidate.hostname.toLowerCase());
  const normalizedPath = candidate.pathname.replace(/\/+$/, "") || "/";
  const giftId = normalizedPath === "/gift"
    ? candidate.searchParams.get("id")
    : (normalizedPath === "/" ? candidate.searchParams.get("gift") : null);

  if (!isAllowedHost || !GIFT_LINK_ID_PATTERN.test(giftId || "")) {
    return {
      destination: "",
      error: "Use the complete gift link from The Gift Conversation.",
    };
  }

  return { destination: candidate.toString(), error: "" };
}

export function buildRecipientProfile(gift = {}) {
  return {
    introducerName: gift.introducer_name,
    recipientName: gift.recipient_name,
    theme: gift.theme,
    tech: gift.tech_comfort,
    work: gift.work,
    outside: gift.outside,
    personality: gift.personality,
    downplay: gift.downplay,
    lightup: gift.lightup,
    avoid: gift.avoid,
  };
}

export function resolveGiftDestination(gift = {}) {
  const profile = buildRecipientProfile(gift);
  const isCompleted = Boolean(
    gift.completed_at || gift.retention_state === "completed"
  );

  if (!isCompleted) {
    return { screen: "landing", profile, prompt: "", error: "" };
  }

  const prompt = typeof gift.generated_prompt === "string"
    ? gift.generated_prompt.trim()
    : "";

  if (!prompt) {
    return {
      screen: "error",
      profile: null,
      prompt: "",
      error: "We found this completed gift, but its keepsake could not be restored. Please contact support.",
    };
  }

  return {
    screen: "output-restored",
    profile,
    prompt,
    error: "",
  };
}
